import theme from '@/src/config/theme'
import styled from 'styled-components'

export const FiltersTitleIcon = () => (
  <StyledComponent className="p-1.5 bg-[#FFD500] rounded-lg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-sliders-horizontal w-4 h-4 text-black">
      <line x1="21" x2="14" y1="4" y2="4"></line>
      <line x1="10" x2="3" y1="4" y2="4"></line>
      <line x1="21" x2="12" y1="12" y2="12"></line>
      <line x1="8" x2="3" y1="12" y2="12"></line>
      <line x1="21" x2="16" y1="20" y2="20"></line>
      <line x1="12" x2="3" y1="20" y2="20"></line>
      <line x1="14" x2="14" y1="2" y2="6"></line>
      <line x1="8" x2="8" y1="10" y2="14"></line>
      <line x1="16" x2="16" y1="18" y2="22"></line>
    </svg>
  </StyledComponent>
)


const StyledComponent = styled.div`
  background: ${theme.colors.primary};
  
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  border-radius: 5px;

  & > svg {
    width: 16px;
  }
`